<!-- TODO: Unstatic-fy the breadcrumbs with update opm ng lib for Breadcrumbs -->
<!-- <section class="usa-section opm-breadcrumbs"><div class="grid-container"><div class="grid-col-10" itemscope="" itemtype="https://schema.org/BreadcrumbList"><span itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem"><a itemprop="item" href="/" class="level0 parent usa-link"><span itemprop="name">OPM.gov</span></a><span><span> / </span><meta itemprop="position" content="0"></span><span itemprop="itemListElement" itemscope="" itemtype="https://schema.org/ListItem"><span itemprop="name">Bargaining Unit Profiles</span><span><meta itemprop="position" content="1"></span></span></span></div></div></section> -->

<opm-breadcrumbs [breadcrumbs]="breadcrumbs"></opm-breadcrumbs>

<div id="MainContentDiv">
  <section id="mainSection" class="usa-section">
    <div id="mainContent">
      <a name="content"></a>
      <div>
        <div id="contentBody">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </section>
</div>

<opm-loading-overlay></opm-loading-overlay>

